import { Injectable } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { DataGrid } from '@sharedModule/models/data-grid.model';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { removeEmptyStrings } from '@sharedModule/utils/form.utils';
import { Observable } from 'rxjs';
import {
  AddVelocityLimitInterface,
  UpdateVelocityLimitInterface,
} from '../types/upsert-velocity-limit';
import { VelocityLimitListInterface } from '../types/velocity-limit-list';
import {
  VelocityLimitListFilter,
  defaultVelocityLimitListFilter,
} from '../types/velocity-limit-list-filter';

@Injectable({
  providedIn: 'root',
})
export class VelocityLimitService {
  constructor(private httpClient: HttpClientService) {}

  getVelocityLimitList(
    payload: VelocityLimitListFilter = defaultVelocityLimitListFilter
  ): Observable<ResponseIdentity<DataGrid<VelocityLimitListInterface[]>>> {
    return this.httpClient.post(
      API_URL_CONSTANT.velocityLimit.getVelocityLimitList,
      removeEmptyStrings(payload)
    );
  }

  getVelocityLimitDetails(payload: {
    id: number;
  }): Observable<ResponseIdentity<VelocityLimitListInterface>> {
    return this.httpClient.post(
      API_URL_CONSTANT.velocityLimit.getVelocityLimitDetails,
      payload
    );
  }

  addVelocityLimit(
    payload: AddVelocityLimitInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.velocityLimit.addVelocityLimit,
      payload
    );
  }

  updateVelocityLimit(
    payload: UpdateVelocityLimitInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.velocityLimit.updateVelocityLimit,
      payload
    );
  }

  deleteVelocityLimit(payload: {
    id: number;
  }): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.velocityLimit.deleteVelocityLimit,
      payload
    );
  }
}
